// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";

import Toasted from "vue-toasted";
import Datepicker from "vuejs-datepicker";
import VueLazyload from "vue-lazyload";
import vueDebounce from "vue-debounce";
import _ from "lodash";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueHtmlToPaper from "vue-html-to-paper";
import "./filters/filters";

import Vuex from "vuex";
import store from "./store";

import VueCookie from "vue-cookie";
Vue.use(VueCookie);
// mixin
import Mixin from "@/util/utilMixin";
import i18n from "@/plugins/i18n";
import ElectronIPC from "@/plugins/electron-ipc";
Vue.use(ElectronIPC);

import "./assets/css/style.css";
import "./assets/css/button.css";
import "../node_modules/slick-carousel/slick/slick.css";
import "./assets/css/slick-theme.css";
import "./assets/css/icons.css";
import "./assets/css/installation.css";
import "./assets/css/akash.css";
import "./assets/css/theme.css";
import "./assets/css/mobileDashboard.css";
import "./assets/css/posCheckout.css";
import "./assets/css/posFnb.css";

import { BASEURL, SOCKETURL } from "@/config/index";
import axios from "axios";

import ProgressBar from "vuejs-progress-bar";
Vue.use(ProgressBar);

import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};
Vue.use(VueHtmlToPaper, options);

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1,
});

Vue.use(vueDebounce);

// added loader
Vue.use(Loading, {
  loader: "bars",
  color: "var(--blue)",
  width: 70,
  zIndex: 9999,
  height: 50,
  backgroundColor: "#4b4b4b",
});
Vue.mixin(Mixin);
Vue.use(BootstrapVue);
Vue.component("Datepicker", Datepicker);

Vue.use(Vuex);

Vue.use(Toasted, {
  duration: 4000,
  position: "top-center",
  singleton: true,
  containerClass: "toast-message",
});

Vue.config.productionTip = false;

// toast message
Vue.use(Toasted, {
  duration: 4000,
  position: "top-center",
  singleton: true,
  containerClass: "toast-message",
});

// Created the Event Bus for the call parent function
export const EventBus = new Vue();

// socket import

import VueSocketIO from "vue-socket.io";
import { initBackendAndElectronSocket } from "./socket.io/init";
const io = require("socket.io-client");

let url = "http://localhost:3001";

var useSocket = initializeSocket(url);

let socket_options = {
  reconnectionAttempts: 3,
  reconnectionDelay: 10000,
};

let socketUrl = SOCKETURL ? SOCKETURL : BASEURL;

function initializeSocket(url) {
  axios
    .get(url)
    .then((response) => {
      if (response && response.status == "200") {
        Vue.toasted.show("Nuvio-POS Connect Successfully.");

        Vue.use(
          new VueSocketIO({
            debug: true,
            connection: url,
            options: socket_options,
          })
        );
        useSocket;
      }
    })
    .catch((err) => {
      // console.log(err);
      Vue.use(
        new VueSocketIO({
          debug: true,
          connection: socketUrl + "/",
          options: socket_options,
        })
      );
      // Vue.toasted.show('Unable to Connect Brij-POS')
    });
}

export const backendSocket = io(socketUrl + "/", {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  transports: ["websocket"],
  upgrade: false,
});
export const electronSocket = io(url, {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  transports: ["websocket"],
  upgrade: false,
});

initBackendAndElectronSocket(backendSocket, electronSocket);

/* eslint-disable no-new */
// global['vmVue'] = new Vue({
//   el: "#app",
//   router,
//   i18n,
//   store,
//   components: {
//     App,
//   },
//   template: "<App/>",
// });

global.vmVue = new Vue({
  i18n,
  el: "#app",
  store,
  router,
  components: {
    App,
  },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js